import { KeyHint } from "../../ui/index.js";

const SHORTCUTS: { keys: string | string[]; label: string }[] = [
  { keys: "Space", label: "Vaqtni start / pauza" },
  { keys: "G", label: "Gol (faol tomon)" },
  { keys: "Y", label: "Sariq karta (faol tomon)" },
  { keys: "R", label: "Qizil karta (faol tomon)" },
  { keys: "S", label: "Almashtirish (faol tomon)" },
  { keys: "Esc", label: "Efirdagi overlay'ni yashirish" },
  { keys: ["Shift", "Esc"], label: "ALL OFF — hamma overlay + VAR'ni yashirish" },
  { keys: "?", label: "Shu yordamni ochish" },
];

/** Static cheat-sheet shown in a drawer. Bindings live in ControlRoom's
 *  useHotkeys call — keep this list in sync with it. */
export function ShortcutsHelp() {
  return (
    <div className="flex flex-col gap-1.5">
      <p className="mb-2 text-[13px] text-ink-muted">
        Yorliqlar matn maydoniga yozayotganda ishlamaydi. "Faol tomon" — oxirgi marta tanlangan
        tomon (Home/Away).
      </p>
      {SHORTCUTS.map((s) => (
        <div
          key={typeof s.keys === "string" ? s.keys : s.keys.join("+")}
          className="flex items-center justify-between gap-4 rounded-md border border-divider bg-surface-muted/40 px-3 py-2"
        >
          <span className="text-[13px] text-ink-soft">{s.label}</span>
          <KeyHint keys={s.keys} />
        </div>
      ))}
    </div>
  );
}
